// extracted by mini-css-extract-plugin
export default {"attentionContainer":"RescheduleOrCancelChoice--attentionContainer--1380d1","button":"RescheduleOrCancelChoice--button--4791d5"};